import React, { memo } from 'react';

const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.529 19.514">
    <path d="M19.483 18.339l-1.976-6.113L6.394 1.173A4.039 4.039 0 0 0 3.615 0a3.562 3.562 0 0 0-2.284.8 3.672 3.672 0 0 0-.247 5.434h.062l11.175 11.179 6.113 2.038a.557.557 0 0 0 .309.062.876.876 0 0 0 .74-1.174zM4.171 7.595l3.458-3.458.617.617-3.458 3.458zM1.948 5.31a2.69 2.69 0 0 1-.679-1.791 2.893 2.893 0 0 1 .864-1.791 2.512 2.512 0 0 1 1.482-.494 2.823 2.823 0 0 1 1.914.8l1.235 1.235L3.307 6.73l-1.3-1.3c.003-.058-.059-.058-.059-.12zm10.99 11.053L5.656 9.077l3.458-3.458 7.286 7.286 1.729 5.125z" />
  </svg>
);

export default memo(EditIcon);
